import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import Sidebar from "../ds/Sidebar/Sidebar";
import "./onboard.scss";
import Header from "../components/organisms/Header/Header";
import NavbarOnboard from "../ds/NavbarOnboard/NavbarOnboard";
import useMobileVhFix from "../hooks/height";

const OnboardingLayout = ({ web, mob }) => {
  useMobileVhFix();

  return (
    <div className="main-layout-onboard">
      <BrowserView>
        <Sidebar />
        <div className="main-wrap-obs">
          <NavbarOnboard />
          {web}
        </div>
      </BrowserView>
      <MobileView>
        <div className="main-wrap-obs">
          <NavbarOnboard />
          {mob}
        </div>
      </MobileView>
    </div>
  );
};

export default OnboardingLayout;
